import { Directive, HostListener, Input, inject } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { AuthClient, CreateUrlSignatureCommand } from '@services';

@Directive({
    selector: '[appSignedLink]',
    standalone: true,
    host: { style: 'cursor: pointer;' },
})
export class SignedLinkDirective {
    @HostListener('click', ['$event'])
    async onClick(event: MouseEvent) {
        event.preventDefault();
        event.stopPropagation();

        if (!this.path || this.path === '#') return;

        try {
            const signedUrl = await lastValueFrom(
                this.authClient.getSignedUrl(
                    new CreateUrlSignatureCommand({ url: this.path }),
                ),
            );

            window.open(signedUrl, '_blank');
        } catch {
            console.error('Failed to load signed URL');
        }
    }

    private authClient = inject(AuthClient);

    @Input('appSignedLink') path?: string | null;
}
